import Model from '../model';





export default Model.extend( {

    endpoint: 'clusters?apiVersion=2.0',
    
    defaults: {
        title: '',
        defaults: null,
    },
    
} );


// WEBPACK FOOTER //
// ./src/js/model/refbooks/cluster.js